import React from 'react';
import Button from '@fv-components/button';
import { useAuth } from './authContext';
import { userManager } from './oidcClient';
import { createDialog, DialogMessageStatus } from '../util-helpers/dialogUtils';

const css = require('../SignoutMenu/SignoutMenu.module.scss');

export default function SignoutAction() {
  const { contextSignout } = useAuth();

  const handleSignout = () => {
    createDialog({
      path: 'signout.html',
      onMessage: async (msg, controller) => {
        if (msg.status === DialogMessageStatus.DialogReadyForToken) {
          const user = await userManager.getUser();
          const idToken = user?.id_token;
          if (controller.dialog && idToken) {
            controller.dialog.messageChild(JSON.stringify({ type: 'idToken', token: idToken }));
          } else {
            controller.reject(new Error('No dialog or idToken available to send.'));
          }
          return;
        }

        if (msg.status === DialogMessageStatus.SignoutComplete) {
          controller.resolve(msg);
          return;
        }

        if (msg.error) {
          controller.reject(new Error(`Auth error from dialog message: ${msg.error}`));
          return;
        }

        controller.reject(new Error('Unknown message from dialog'));
      },
    })
      .then(async () => {
        await userManager.removeUser();
        contextSignout();
      })
      .catch((error) => {
        console.error('SignoutAction error:', error);
      });
  };

  return (
    <Button
      className={css.signOutBtn}
      onClick={handleSignout}>
      Sign out of
      <br />
      Filevine
    </Button>
  );
}

